import React from "react";
import cl from "classnames";
import { connect, Field } from "formik";
import stage0Classes from "../../styles/initialEventDetails.module.scss";

const Checkbox = connect(({ formik, name, children }) => (
  <div>
    <Field
      type="checkbox"
      className={cl("ux-checkbox", stage0Classes.FlexibleInput)}
      checked={formik.values[name]}
      name={name}
      id={name}
      onChange={({ target: { checked } }) =>
        formik.setFieldValue(name, checked)
      }
      data-ga={name}
    />
    <label htmlFor={name} className={stage0Classes.CheckboxLabel}>
      {children}
    </label>
  </div>
));

export default Checkbox;
